/**
 * Opciones del bordado — sincronización con el pedido
 * Guardar como: assets/embroidery-options.js
 *
 * Por qué existe:
 *   En este tema, el atributo form= no siempre reconecta los campos al
 *   formulario del producto, así que sus valores no llegan al carrito.
 *   Este script copia cada opción (color de hilo, posición, orientación)
 *   a un input oculto DENTRO del formulario real, que sí se envía.
 */
(function () {
  'use strict';

  function findForm(el) {
    // El formulario que sí llega al pedido: el que contiene el add-to-cart
    return (
      el.closest('form[action*="/cart/add"]') ||
      el.closest('form.product-form') ||
      el.closest('.shopify-section') && el.closest('.shopify-section').querySelector('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]')
    );
  }

  function ensureHidden(form, propName) {
    var hidden = form.querySelector('input[type="hidden"][data-opt-hidden][data-prop="' + cssEscape(propName) + '"]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = propName;
      hidden.setAttribute('data-opt-hidden', 'true');
      hidden.setAttribute('data-prop', propName);
      form.appendChild(hidden);
    }
    return hidden;
  }

  function syncSelect(field) {
    if (field.dataset.optSynced === 'true') return;
    var form = findForm(field);
    if (!form) return;
    // La propiedad real viene en data-emb-prop; name= se acepta por
    // compatibilidad con bloques viejos.
    var name = field.getAttribute('data-emb-prop') || field.getAttribute('name');
    if (!name) return;

    field.dataset.optSynced = 'true';
    var hidden = ensureHidden(form, name);

    // Si el select traía name propio, se lo quitamos: ahora manda el hidden
    if (field.hasAttribute('name')) field.removeAttribute('name');

    function update() { hidden.value = field.value; }
    field.addEventListener('change', update);
    field.addEventListener('input', update);
    update();
  }

  /* ---- Estado "Sin bordar" -------------------------------------------
     Cuando el cliente elige la tercera tarjeta, el bordado no aplica:
       · se esconden hilo, orientación y el selector de tipografía (CSS,
         vía la bandera data-emb-none en <body>)
       · se esconden los campos de Textbox (lo hace embroidery-font.js,
         que lee la misma bandera)
       · se desactivan los inputs ocultos, para que ninguna propiedad de
         bordado llegue al pedido. Sí se conserva "Posición: Sin bordar".
     Todo es reversible: si vuelve a elegir pico o 90°, reaparece. */
  var POSITION_PROP = null;

  function applyNoEmbroidery() {
    if (!document.body) return;

    var off = !!document.querySelector(
      '.emb-options input[type="radio"][data-emb-no-embroidery]:checked'
    );
    var flag = off ? 'true' : 'false';

    if (document.body.getAttribute('data-emb-none') !== flag) {
      document.body.setAttribute('data-emb-none', flag);
    }

    // Un input disabled no se envía con el formulario.
    var hiddens = document.querySelectorAll(
      'input[type="hidden"][data-opt-hidden], input[type="hidden"][data-bordado-hidden]'
    );
    for (var i = 0; i < hiddens.length; i++) {
      var h = hiddens[i];
      var isPosition = POSITION_PROP && h.getAttribute('data-prop') === POSITION_PROP;
      h.disabled = off && !isPosition;
    }
  }

  function syncRadioGroup(radio) {
    // El name local (emb-thread-...) agrupa visualmente los radios.
    // La propiedad real del pedido viene en data-emb-prop.
    var localName = radio.getAttribute('name');
    var propName = radio.getAttribute('data-emb-prop');
    if (!localName || !propName) return;

    var group = document.querySelectorAll(
      '.emb-options input[type="radio"][name="' + cssEscape(localName) + '"]'
    );
    if (!group.length || group[0].dataset.optSynced === 'true') return;

    var form = findForm(radio);
    if (!form) return;

    var hidden = ensureHidden(form, propName);

    // ¿Es el grupo de posición (el que trae la tarjeta "Sin bordar")?
    var hasNone = false;
    for (var k = 0; k < group.length; k++) {
      if (group[k].hasAttribute('data-emb-no-embroidery')) hasNone = true;
    }
    if (hasNone) POSITION_PROP = propName;

    function update() {
      var checked = null;
      for (var i = 0; i < group.length; i++) {
        if (group[i].checked) checked = group[i].value;
      }
      hidden.value = checked || '';
      if (hasNone) applyNoEmbroidery();
    }

    for (var j = 0; j < group.length; j++) {
      group[j].dataset.optSynced = 'true';
      group[j].addEventListener('change', update);
    }
    update();
  }

  function syncField(field) {
    if (field.type === 'radio') {
      syncRadioGroup(field);
    } else {
      syncSelect(field);
    }
  }

  function cssEscape(s) {
    return String(s).replace(/"/g, '\\"');
  }

  function scan() {
    // Selects (posición, orientación) y radios (color de hilo) de nuestro bloque
    var fields = document.querySelectorAll(
      '.emb-options select[data-emb-prop], ' +
      '.emb-options select[name^="properties["], ' +
      '.emb-options textarea[data-emb-prop], ' +
      '.emb-options input[type="radio"][data-emb-prop]'
    );
    for (var i = 0; i < fields.length; i++) syncField(fields[i]);

    // Textbox y el sticky add-to-cart re-renderizan: reafirmamos el estado
    applyNoEmbroidery();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Reintento por si el bloque monta tarde
  window.setTimeout(scan, 1000);

  // Si el tema re-renderiza la sección de producto
  if (window.MutationObserver && document.body) {
    var mo = new MutationObserver(function () { scan(); });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();